<template>
  <div>
    <div class="cal-sans-regular black--text font-size-28 pb-2 mt-3" style="border-bottom: 3px solid #4caf50">World Building</div>
  </div>
</template>

<script>
export default {
  name: 'StorySettings',
}
</script>